//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('product', ['baseCompleteTests']),
    symptoms () {
      return this.$t('completeTestingPlan.symptoms.items')
    }
  }
}
